// extracted by mini-css-extract-plugin
export default {"appointmentCalendar":"AppointmentCalendar_appointmentCalendar__CEPHe"};